import { sendRegistrationToServer } from '../helper/pushHelper';
import { getRootPushRegistration } from './rootPushRegistration';
import { commitCapabilities } from './capabilities';

let restoring;
export async function restoreLegacyWorker({ actorId, current = () => true } = {}) {
  if (!Number.isSafeInteger(actorId) || actorId <= 0 || !navigator.serviceWorker || !window.PushManager) return;
  if (restoring?.actorId === actorId) return restoring.promise;
  const operation = restore({ actorId, current });
  restoring = { actorId, promise: operation };
  try { return await operation; }
  finally { if (restoring?.promise === operation) restoring = null; }
}

async function restore({ actorId, current }) {
  const { data: capability } = await window.axios.get('/api/v1/attention_capabilities', { timeout: 2000 });
  if (!current()) return;
  commitCapabilities(capability, actorId);
  if (!capability.legacy_account_ids.length || !capability.native_enabled) return;
  const attention = await navigator.serviceWorker.getRegistration('/app/');
  if (!current()) return;
  let previouslySubscribed = false;
  if (attention?.active?.scriptURL === `${location.origin}/attention-sw.js` && !capability.attention_enabled) {
    let deviceId; let owned;
    try {
      deviceId = localStorage.getItem('reliable-attention-device');
      if (deviceId) owned = (await window.axios.get('/api/v1/attention_devices', { params: { device_id: deviceId }, timeout: 2000 })).data;
    } catch { return; }
    if (!current() || owned?.attention_enabled !== false) return;
    if (owned.owned === true) {
      if (owned.actor_id !== actorId || !owned.binding_id || !owned.cleanup_token || !Number.isSafeInteger(owned.registration_revision)) return;
      const cleared = await new Promise(resolve => {
        const channel = new MessageChannel();
        const timeout = setTimeout(() => { channel.port1.close(); resolve(null); }, 1500);
        channel.port1.onmessage = event => { clearTimeout(timeout); channel.port1.close(); resolve(event.data); };
        attention.active.postMessage({ type: 'ATTENTION_CLEAR', ...owned }, [channel.port2]);
      });
      if (!current()) return;
      // Optional CAS cleanup never adopts or deletes a replacement binding.
      // Even a declined CLEAR leaves a feature-off worker unable to dispatch.
      if (cleared?.cleared === true) {
        previouslySubscribed = !!await attention.pushManager.getSubscription();
        if (!current()) return;
        try { await window.axios.delete('/api/v1/attention_devices', {
          data: { device_id: deviceId, binding_id: owned.binding_id, cleanup_token: owned.cleanup_token }, timeout: 2000,
        }); } catch { /* Server feature/session validation stops stale delivery. */ }
      }
    } else if (owned.owned !== false) return;
    // owned:false is a valid result after normal cleanup deleted the row.
    // Leave the shared /app/ worker, subscription and another actor intact.
  }
  if (!current()) return;
  const root = await getRootPushRegistration();
  if (!current() || Notification.permission !== 'granted') return;
  let subscription = await root.pushManager.getSubscription();
  if (!current()) return;
  if (!subscription && (capability.native_opted_in === true || previouslySubscribed) && window.chatwootConfig.vapidPublicKey) {
    subscription = await root.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: window.chatwootConfig.vapidPublicKey });
  }
  if (current() && subscription) await sendRegistrationToServer(subscription);
}
